import React, { useEffect, useState, useRef } from 'react';
import './GlobalTopLoader.css';

export default function GlobalTopLoader() {
  const [active, setActive] = useState(false);
  const [finishing, setFinishing] = useState(false);
  const finishTimeoutRef = useRef(null);

  useEffect(() => {
    const handleBusy = (event) => {
      const isBusy = Boolean(event.detail?.active);
      if (finishTimeoutRef.current) {
        clearTimeout(finishTimeoutRef.current);
        finishTimeoutRef.current = null;
      }

      if (isBusy) {
        setFinishing(false);
        setActive(true);
      } else {
        // Complete the bar to 100% and fade out
        setFinishing(true);
        finishTimeoutRef.current = setTimeout(() => {
          setActive(false);
          setFinishing(false);
        }, 350);
      }
    };

    window.addEventListener('app-api-busy', handleBusy);
    return () => {
      window.removeEventListener('app-api-busy', handleBusy);
      if (finishTimeoutRef.current) clearTimeout(finishTimeoutRef.current);
    };
  }, []);

  if (!active && !finishing) return null;

  return (
    <div className={`global-top-loader ${active ? 'active' : ''} ${finishing ? 'finishing' : 'loading'}`}>
      <div className="global-top-loader-bar" />
    </div>
  );
}
